<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card elevation="0" class="v-card-bottom-30">
      <v-card-title class="body-1">
        {{use_language.stock}}
        <v-icon>mdi-chevron-right</v-icon>
        <a @click="toBack('my-stock')"> {{use_language.product_stock}} </a>
        <v-icon>mdi-chevron-right</v-icon>
        {{use_language.add_from_excel}}
      </v-card-title>
    </v-card>

    <!-- ส่วนอัพโหลด -->
    <v-card>
      <v-row>
        <v-col cols="12" md="12">
          <v-row align="center">
            <v-col cols="12" lg="6" class="py-1" align="start">
              <v-icon size="22" color="teal darken-3">mdi mdi-home-assistant</v-icon>
              <span class="ml-3">{{use_language.import_product_excel}}</span>
            </v-col>

            <v-col
              v-if="selectType == 1"
              cols="12"
              md="6"
              class="py-3"
              align="end"
            >
              <v-btn
                :elevation="1"
                color="success"
                class="mr-3 mt-1"
                href="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/ExcelTemplate/template_upload_stock_v2.xlsx"
              >
                <v-icon left>mdi-download</v-icon>
                Download template
              </v-btn>
            </v-col>

            <v-col
              v-if="selectType == 2"
              cols="12"
              md="6"
              class="py-3"
              align="end"
            >
              <v-btn
                :elevation="1"
                color="success"
                class="mr-3 mt-1"
                href="https://packhaistorage.s3.ap-southeast-1.amazonaws.com/TemplateCreateProductSetV2.xlsx"
              >
                <v-icon left>mdi-download</v-icon>
                Download template
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="pb-2">
        <v-col cols="12" md="8" align="start">
          <v-row>
            <v-col cols="12" md="4" class="py-0">
              <h3 class="fn-14">Step 1 : {{use_language.select_type}}</h3>
            </v-col>
            <v-col cols="12" md="8" class="py-0">
              <v-radio-group v-model="selectType" row>
                <v-radio :label="use_language.add_edit + ' ' + use_language.general_product" :value="1" />
                <v-radio :label="use_language.add_edit + ' ' + use_language.set_products" :value="2" />
                <v-radio :label="use_language.edit + use_language.stock_sync_percent" :value="3" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="selectType == 1" align="center">
            <v-col cols="12" md="4" class="py-0">
              <h3 class="fn-14">Step 2 : {{use_language.select_library}}</h3>
            </v-col>
            <v-col cols="12" md="8" class="py-0">
              <v-autocomplete
                ref="selcet_shop"
                v-model="warehouseId"
                :items="warehouseList"
                item-text="name"
                item-value="id"
                persistent-hint
                return-object
                dense
                hide-details
                outlined
                single-line
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="12" md="4" class="py-0">
              <h3 class="fn-14">
                Step {{ selectType == 1 ? "3" : "2" }} : {{use_language.upload_files}}
              </h3>
            </v-col>
            <v-col v-if="selectType == 1" cols="12" md="8">
              <v-file-input
                v-model="file_excel"
                ref="file_excel"
                color="deep-purple accent-4"
                :placeholder="use_language.please_select_excel_file_only"
                prepend-icon=""
                outlined
                hide-details
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 2"
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} file_excel(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>

            <v-col v-if="selectType == 2" cols="12" md="8">
              <v-file-input
                v-model="fileSet_excel"
                ref="fileSet_excel"
                color="deep-purple accent-4"
                :placeholder="use_language.please_select_excel_file_only"
                prepend-icon=""
                outlined
                hide-details
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <template v-slot:selection="{ text }">
                  <v-chip color="deep-purple accent-4" dark label small>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
              <span v-if="percentLoadingWork" class="text-danger"
                >{{ this.percentLoadingText }} {{ this.percentLoading }} %</span
              >
            </v-col>

            <v-col v-if="selectType == 3" cols="12" md="8">
              <v-file-input
                v-model="filePercent_excel"
                ref="filePercent_excel"
                color="deep-purple accent-4"
                :placeholder="use_language.please_select_file"
                prepend-icon=""
                outlined
                hide-details
              >
                <template v-slot:selection="{ text }">
                  <v-chip color="deep-purple accent-4" dark label small>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
              <span v-if="percentLoadingWork" class="text-danger"
                >{{ this.percentLoadingText }} {{ this.percentLoading }} %</span
              >
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="12" md="4" class="py-0">
              <h3 class="fn-14">
                Step {{ selectType == 1 ? "4" : "3" }} : {{use_language.save}}
              </h3>
            </v-col>
            <v-col v-if="selectType == 1" cols="12" lg="8" align="start">
              <v-btn
                color="primary"
                @click="upload_order_excel()"
                v-if="!fetch_api_present"
              >
                <v-icon left>mdi-content-save</v-icon><span>{{use_language.save}}</span>
              </v-btn>
              <v-btn color="danger" v-else>
                <h3>{{use_language.in_progress}} {{ present_wait }} %</h3>
              </v-btn>
            </v-col>

            <v-col v-if="selectType == 2" cols="12" lg="8" align="start">
              <v-btn
                @click="updateProductSet"
                color="primary"
                v-if="!fetch_api_present_set"
                :disabled="setSuccessList.length == 0"
              >
                <v-icon left>mdi-content-save</v-icon><span>{{use_language.save}}</span>
              </v-btn>
              <v-btn color="primary" v-else>
                <h3>{{use_language.in_progress}} {{ present_setWait }} %</h3>
              </v-btn>
            </v-col>

            <v-col v-if="selectType == 3" cols="12" lg="8" align="start">
              <v-btn
                @click="updateSyncStock"
                color="primary"
                v-if="!fetch_api_present_percent"
                :disabled="percentList.length == 0"
              >
                <v-icon left>mdi-content-save</v-icon><span>{{use_language.save}}</span>
              </v-btn>
              <v-btn color="primary" v-else>
                <h3>{{use_language.in_progress}} {{ present_percentWait }} %</h3>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <!-- pop up แสดงผลหลักทำงานเสร็จ -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="12" md="10 " align-self="center">{{use_language.import_result}}</v-col>
            <v-col cols="12" md="2">
              <v-btn icon @click="(dialog = false), updatePage(1)">
                <v-icon right>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>

        <v-card-text>
          <v-row justify="center" class="py-5">
            <v-col cols="12" md="4">
              <h3 style="color: black">{{use_language.total_all}} :</h3>
            </v-col>
            <v-col cols="12" md="2">
              <h3 style="color: black">{{ this.total_excal }}</h3>
            </v-col>
            <v-col cols="12" md="4">
              <h3 style="color: black">{{use_language.list}}</h3>
            </v-col>
          </v-row>
          <v-row justify="center" class="py-5">
            <v-col cols="12" md="4">
              <h3 style="color: green">{{use_language.save_success}} :</h3>
            </v-col>
            <v-col cols="12" md="2">
              <h3 style="color: green">{{ this.count_successes }}</h3>
            </v-col>
            <v-col cols="12" md="4">
              <h3 style="color: green">{{use_language.list}}</h3>
            </v-col>
          </v-row>
          <v-row justify="center" class="py-5">
            <v-col cols="12" md="4">
              <h3 style="color: red">{{use_language.save_fail}} :</h3>
            </v-col>
            <v-col cols="12" md="2">
              <h3 style="color: red">{{ this.count_failed }}</h3>
            </v-col>
            <v-col cols="12" md="4">
              <h3 style="color: red">{{use_language.list}}</h3>
            </v-col>
          </v-row>
          <v-row class="py-5">
            <v-col col="12" md="6">
              <v-btn
                block
                elevation="2"
                outlined
                x-large
                @click="(dialog = false), updatePage(1)"
              >
                <label>{{use_language.check_order_fail}}</label>
              </v-btn>
            </v-col >
            <v-col col="12" md="6">
              <v-btn
                block
                color="primary"
                elevation="2"
                tile
                x-large
                @click="toBack('my-stock')"
              >
                <label>{{use_language.to_stock_page}}</label>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ส่วน data-table -->
    <v-card class="py-3 ma-7 px-6 mx-0 v-card-margin-bottom-30" v-if="length_page > 0">
      <v-row>
        <v-col cols="4">
          <h3>{{use_language.all_info}} {{ this.total_excal }} {{use_language.row}}</h3>
        </v-col>
        <v-col>
          <v-row>
            <v-col cols="12" md="4" class="text-center" style="color: orange">
              <h3>{{use_language.in_progress}} {{ this.total_excal - this.count_successes - this.count_failed}}</h3>
            </v-col>
            <v-col cols="12" md="4" class="text-center" style="color: green">
              <h3>{{use_language.done}} {{ this.count_successes }}</h3>
            </v-col>
            <v-col cols="12" md="4" class="text-center" style="color: red">
              <h3>{{use_language.add_fail}} {{ this.count_failed }}</h3>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-simple-table class="packhai-border-table" width="100%">
        <thead>
          <tr>
            <th class="text-center" width="10%">{{use_language.status}}</th>
            <th class="text-center" width="50%">{{use_language.product}}</th>
            <th class="text-center" width="10%">sku</th>
            <th class="text-center" width="10%">{{use_language.selling_price}}</th>
            <th class="text-center" width="10%">buffer</th>
            <th class="text-center" width="10%">{{use_language.stock}}</th>
          </tr>
        </thead>
        <tbody>
          <tr align="center" v-for="item in historyList" :key="item.index">
            <td v-if="item.status == 0">
              <span style="color: orange">{{use_language.wait_upload}}</span>
            </td>
            <td v-if="item.status == 1">
              <span style="color: green">
                <v-icon left style="color: green">mdi-checkbox-marked-circle-outline</v-icon>
                {{use_language.success}}
              </span>
            </td>
            <td v-if="item.status == 2 || item.status == 3">
              <span style="color: red">
                <v-icon left style="color: red">mdi-close-octagon-outline</v-icon>
                {{use_language.fail}} 
                <small>{{ item.error }}</small>
              </span>
            </td>
            <td>
              <table width="100%">
                <tr>
                  <td
                    width="15%"
                    align="center"
                    class="tablenone"
                    v-if="!item.url_img || item.url_img.includes('drive.google') || item.url_img.includes('scontent.fbkk')">
                    <div class="box_img" />
                  </td>
                  <td width="15%" align="center" class="tablenone" v-else>
                    <v-img max-height="100" max-width="100" :src="item.url_img"></v-img>
                  </td>

                  <td width="85%" class="tablenone">
                    <v-row>
                      <v-col cols="12" md="12"><h4>{{ item.name }}</h4></v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <span style="color: gray">
                          <template v-if="item.barcode != null || item.barcode == ''">
                            Barcode : {{ item.barcode }}
                          </template>
                          <template v-if="item.code != null || item.code == ''" >
                            , {{use_language.number_product}} : {{ item.code }}
                          </template>
                          <template v-if="item.cf != null || item.cf == ''">
                            , {{use_language.code_cf}} : {{ item.cf }}
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <span style="color: gray">
                          <template v-if="item.attribute1 != null || item.attribute1 == ''">
                            {{ item.attribute1 }} :
                            {{ item.details_attribute1 }}
                          </template>
                          <template v-if="item.attribute2 != null || item.attribute2 == ''">
                            ,{{ item.attribute2 }} :
                            {{ item.details_attribute2 }}
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </table>
            </td>
            <td>
              <span> {{ item.sku }}</span>
            </td>
            <td>
              <span>{{ item.price }}</span>
            </td>
            <td>
              <span>{{ item.buffer }}</span>
            </td>
            <td>
              <span>{{ item.stock }}</span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-row> </v-row>

      <div class="text-center py-3" v-if="length_page > 0">
        <v-pagination
          v-model="page"
          :length="length_page"
          :total-visible="7"
          @input="updatePage"
        ></v-pagination>
      </div>
    </v-card>

    <!-- ส่วน set data-table -->
    <div class="py-3 ma-7 mx-0 v-card-margin-bottom-30" v-if="showSetTable == true && selectType != 3">
      <v-tabs v-model="tab" class="pb-3">
        <v-tabs-slider></v-tabs-slider>
        <v-tab> {{use_language.pending_item}} ({{ this.setSuccessList.length }}) </v-tab>
        <v-tab> {{use_language.defective_product}} ({{ this.setFailedList.length }}) </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" touchless>
        <!-- set success -->
        <v-tab-item>
          <v-card
            v-for="(itemMain, index) in setSuccessList"
            :key="index"
            elevation="1"
            class="v-card-bottom-30"
          >
            <v-card-title>
              {{ "(" + (index + 1) + ")" }} {{ itemMain.mainProduct.sku }}
            </v-card-title>
            <v-divider />

            <v-card-text class="pa-0">
              <v-row>
                <v-col cols="12">
                  <table style="width: 100%">
                    <tr>
                      <td rowspan="5" style="width: 100px">
                        <a
                          v-if="itemMain.mainProduct.photoLink != null && itemMain.mainProduct.photoLink != ''"
                          class="v-avatar v-list-item__avatar my-0 rounded-0 v-avatar--tile"
                        >
                          <img :src="itemMain.mainProduct.photoLink" class="picsize"/>
                        </a>
                      </td>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.name_product }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.name }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.type }} :
                      </td>
                      <td>
                        {{
                          (itemMain.mainProduct.prop1Description != null &&
                          itemMain.mainProduct.prop1Description != ""
                            ? itemMain.mainProduct.prop1Description
                            : "") +
                          (itemMain.mainProduct.prop2Description != null &&
                          itemMain.mainProduct.prop2Description != ""
                            ? " , " + itemMain.mainProduct.prop2Description
                            : "")
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.sku }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.sku }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.barcode }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.barcode }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.remark }} :
                      </td>
                      <td style="color: red">
                        {{ itemMain.mainProduct.remark }}
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text>
              <h3>{{use_language.item_include_set}}</h3>
              <v-data-table
                :headers="setSuccessHeader"
                :items="itemMain.subProducts"
                :items-per-page="9999999999"
                hide-default-footer
                class="packhai-border-table hidden-xs-only"
              >
                <template v-slot:item.no="{ item }">
                  {{ formatMoney(itemMain.subProducts.indexOf(item) + 1) }}
                </template>
                <template v-slot:item.photoLink="{ item }">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    icon
                    @click="OpenPhoto(item.photoLink)"
                  >
                    <img :src="item.photoLink" class="picsize mt-1" />
                  </a>
                </template>
                <template v-slot:item.prop1Description="{ item }">
                  <span class="fn-13">
                    {{
                      (item.prop1Description != null &&
                      item.prop1Description != ""
                        ? item.prop1Description
                        : "") +
                      (item.prop2Description != null &&
                      item.prop2Description != ""
                        ? " , " + item.prop2Description
                        : "")
                    }}
                  </span>
                </template>
                <template v-slot:item.quantity="{ item }">
                  {{ formatMoney(item.quantity) }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- set failed -->
        <v-tab-item>
          <v-card
            v-for="(itemMain, index) in setFailedList"
            :key="index"
            elevation="1"
            class="v-card-bottom-30"
          >
            <v-card-title>
              {{ "(" + (index + 1) + ")" }} {{ itemMain.mainProduct.sku }}
            </v-card-title>
            <v-divider />

            <v-card-text class="mt-n5">
              <v-row>
                <v-col cols="12">
                  <table style="width: 100%">
                    <tr>
                      <td rowspan="5" style="width: 100px">
                        <a
                          v-if="itemMain.mainProduct.photoLink != null && itemMain.mainProduct.photoLink != ''"
                          class="v-avatar v-list-item__avatar my-0 rounded-0 v-avatar--tile"
                        >
                          <img :src="itemMain.mainProduct.photoLink" class="picsize"/>
                        </a>
                      </td>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.name_product }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.name }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.type }} :
                      </td>
                      <td>
                        {{
                          (itemMain.mainProduct.prop1Description != null &&
                          itemMain.mainProduct.prop1Description != ""
                            ? itemMain.mainProduct.prop1Description
                            : "") +
                          (itemMain.mainProduct.prop2Description != null &&
                          itemMain.mainProduct.prop2Description != ""
                            ? " , " + itemMain.mainProduct.prop2Description
                            : "")
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.sku }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.sku }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.barcode }} :
                      </td>
                      <td>
                        {{ itemMain.mainProduct.barcode }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 100px; font-weight: bold">
                        {{ use_language.remark }} :
                      </td>
                      <td style="color: red">
                        {{ itemMain.mainProduct.remark }}
                      </td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text>
              <h3>{{use_language.item_include_set}}</h3>
              <v-data-table
                :headers="setFailedHeader"
                :items="itemMain.subProducts"
                :items-per-page="9999999999"
                hide-default-footer
                class="packhai-border-table hidden-xs-only"
              >
                <template v-slot:item.no="{ item }">
                  {{ formatMoney(itemMain.subProducts.indexOf(item) + 1) }}
                </template>
                <template v-slot:item.photoLink="{ item }">
                  <a
                    v-if="item.photoLink != null && item.photoLink != ''"
                    icon
                    @click="OpenPhoto(item.photoLink)"
                  >
                    <img :src="item.photoLink" class="picsize mt-1" />
                  </a>
                </template>
                <template v-slot:item.prop1Description="{ item }">
                  <span class="fn-13">
                    {{
                      (item.prop1Description != null &&
                      item.prop1Description != ""
                        ? item.prop1Description
                        : "") +
                      (item.prop2Description != null &&
                      item.prop2Description != ""
                        ? " , " + item.prop2Description
                        : "")
                    }}
                  </span>
                </template>
                <template v-slot:item.quantity="{ item }">
                  {{ formatMoney(item.quantity) }}
                </template>
                <template v-slot:item.remark="{ item }">
                  <div class="text-danger">{{ item.remark }}</div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- ส่วน sync stock -->
    <div class="py-10 v-card-margin-bottom-30" v-if="percentHeader.length != 0 && selectType == 3">
      <v-card>
        <v-data-table
          :headers="percentHeader"
          :items="percentList"
          :items-per-page="9999999999"
          hide-default-footer
          class="packhai-border-table hidden-xs-only"
        >
          <template v-slot:item.no="{ item }">
            {{ formatMoney(percentList.indexOf(item) + 1) }}
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "@/website/components/Loading";
import { stockService_dotnet, shopService_dotnet } from "@/website/global";
import readXlsxFile from "read-excel-file";
import { AlertSuccess, AlertWarning, AlertError } from "@/website/global_alert";
import { formatMoney, get_languages } from "@/website/global_function";

export default {
  components: {
    Loading,
  },
  data: () => ({
    header_token: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorization_token"),
    },
    dialog: false,
    ShopID: parseInt(localStorage.getItem("shop_id")),
    staffShopID: parseInt(localStorage.getItem("staff_id")),
    use_language: null,
    // page
    page_loading: true,
    loading: false,

    page: 1,
    total_excal: 0,
    pageSize: 10,
    historyList: [],
    length_page: 0,

    //excel
    dataTable_excal: [],
    file_excel: [],
    count_excel: 0,
    count_successes: 0,
    count_failed: 0,
    fetch_api_present: 0,
    present_status: false,

    // download template
    dataTable: [],

    //seclectwarehouse
    warehouseList: [{ id: 0, name: "-- เลือกคลัง --", disabled: true }],
    warehouseId: { id: 0, name: "-- เลือกคลัง --", disabled: true },

    productMaster: {},

    productMasterItem: [{}],

    //file set
    tab: null,
    selectType: 1,
    fileSet_excel: null,
    setSuccessList: [],
    setFailedList: [],
    showSetTable: false,
    countSuccess: 0,
    fetch_api_present_set: 0,

    // stub [] in data(); rebuilt with use_language in getHeaderDatatable() (headers-trap)
    setSuccessHeader: [],

    setFailedHeader: [],

    percentLoadingWork: false,
    percentLoading: 0,
    percentLoadingText: "",

    //file percent
    filePercent_excel: null,
    percentList: [],
    percentHeader: [],
    showPercentTable: false,
    percentCountSuccess: 0,
    fetch_api_present_percent: 0,
  }),
  async created() {
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    await this.getHeaderDatatable()
    await this.getSelcetWarehouse();
    this.page_loading = false;
  },
  watch: {
    selectType() {
      if (this.selectType == 1 || this.selectType == 3) {
        this.showSetTable = false;
      } else if (this.selectType == 2 && this.fileSet_excel == null) {
        this.showSetTable = false;
      } else {
        this.showSetTable = true;
      }
    },

    file_excel() {
      let row = [];
      readXlsxFile(this.file_excel).then(async (rows) => {
        var rowColumnLength = rows[0].length;

        if (
          rows[0].length != 19 && 
          rows[0].length != 31
        ) {
          this.$swal({
            type: "warning",
            text: this.use_language.excel_column_incorrect,
          });
          this.file_excel = null;
          return;
        }
        if (
          (rows[0].length == 19) &&
          rows[0][0] != "ชื่อสินค้า" &&
          rows[0][12] != "สต๊อก"
        ) {
          this.$swal({
            type: "warning",
            text: this.use_language.excel_template_incorrect,
          });
          this.file_excel = null;
          return;
        }
        if ((rows[0].length ==  31) && rows[0][0] != "ProductID") {
          this.$swal({
            type: "warning",
            text: this.use_language.excel_template_incorrect,
          });
          this.file_excel = null;
          return;
        }
        for (var i in rows) {
          if (i > 0) {
            if (rowColumnLength ==19) {
              row.push({
                productMasterID: 0,
                productMasterItemID: 0,
                stockShopID: 0,
                name: rows[i][0],
                code: rows[i][1],
                sku: rows[i][2],
                barcode: rows[i][3],
                cf: rows[i][4],
                price: rows[i][5],
                attribute1: rows[i][6],
                details_attribute1: rows[i][7],
                attribute2: rows[i][8],
                details_attribute2: rows[i][9],
                url_img: rows[i][10],
                weight: rows[i][11],
                cubic1: rows[i][12],
                cubic2: rows[i][13],
                cubic3: rows[i][14],
                buffer: rows[i][15],
                stock: rows[i][16],
                acceptableExpiryDay: rowColumnLength >= 19 ? rows[i][18] : null,
                acceptableMFGDay: rowColumnLength >= 19 ? rows[i][17] : null,
                isproductset: false,
                status: 0,
                index: i - 1,
                isAddTemplate: true,
              });
            } else {
              row.push({
                productMasterID: rows[i][0],
                productMasterItemID: rows[i][1],
                stockShopID: rows[i][2],
                name: rows[i][4],
                attribute1: rows[i][5],
                details_attribute1: rows[i][6],
                attribute2: rows[i][7],
                details_attribute2: rows[i][8],
                costPrice: rows[i][9],
                price: rows[i][10],
                code: rows[i][11],
                cf: rows[i][12],
                sku: rows[i][13],
                barcode: rows[i][14],
                weight: rows[i][15],
                cubic1: rows[i][16],
                cubic2: rows[i][17],
                cubic3: rows[i][18],
                stock: rows[i][19],
                buffer: rows[i][20],
                brand: rows[i][26],
                isproductset: rows[i][27] == "จัดเซ็ท" ? true : false,
                url_img: rows[i][28],
                acceptableExpiryDay: rowColumnLength >= 31 ? rows[i][30] : null,
                acceptableMFGDay: rowColumnLength >= 31 ? rows[i][29] : null,
                status: 0,
                index: i - 1,
                isAddTemplate: false,
              });
            }
          }
        }
        this.count_excel = this.total_excal = row.length;
        this.dataTable_excal = row;
        this.updatePage(1);
      });
    },

    fileSet_excel() {
      if (this.fileSet_excel != null) {
        let row = [];
        readXlsxFile(this.fileSet_excel).then(async (rows) => {
          var rowColumnLength = rows[0].length;
          if (rows[0].length != 5 && rows[0].length != 7) {
            this.$swal({
              type: "warning",
              text: this.use_language.excel_column_incorrect,
            });
            this.fileSet_excel = null;
            return;
          }
          if (rows[0][0] != "SKU สินค้าหลัก" && rows[0][4] != "จำนวนชิ้น") {
            this.$swal({
              type: "warning",
              text: this.use_language.excel_template_incorrect,
            });
            this.fileSet_excel = null;
            return;
          }
          var setMainSku = "";
          var setMainBarcode = "";
          for (var i in rows) {
            if (i > 0) {
              if (rowColumnLength == 5 || rowColumnLength == 7) {
                var hasMainSku = rows[i][0] != "" && rows[i][0] != null;
                var hasMainBarcode = rows[i][1] != "" && rows[i][1] != null;
                if (hasMainSku || hasMainBarcode) {
                  setMainSku = hasMainSku ? rows[i][0].toString() : "";
                  setMainBarcode = hasMainBarcode ? rows[i][1].toString() : "";
                }
                row.push({
                  mainSku: setMainSku,
                  mainBarcode: setMainBarcode,
                  subSku: rows[i][2] != null ? rows[i][2].toString() : "",
                  subBarcode: rows[i][3] != null ? rows[i][3].toString() : "",
                  quantity: rows[i][4],
                });
              }
            }
          }
          this.checkProductSet(row);
        });
      } else {
        this.fileSet_excel = null;
        this.setSuccessList = [];
        this.setFailedList = [];
        this.showSetTable = false;
      }
    },

    filePercent_excel() {
      this.percentHeader = [];
      this.percentList = [];
      this.fetch_api_present_percent = 0;
      if (this.filePercent_excel != null) {
        let row = [];
        readXlsxFile(this.filePercent_excel).then(async (rows) => {
          this.percentHeader.push({
            text: "No",
            align: "center",
            sortable: false,
            value: "no",
            width: "60px",
          });
          var headList = rows[0];
          var bodyList = rows;
          for (let i = 0; i < headList.length; i++) {
            if (i == 0) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "id",
                width: "60px",
              });
            } else if (i == 1) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "name",
              });
            } else if (i == 2) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "sku",
              });
            } else if (i == 3) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "barcode",
              });
            } else if (i == 4) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "productCode",
              });
            } else if (i == 5) {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: "prop",
              });
            } else {
              this.percentHeader.push({
                text: headList[i],
                align: "center",
                sortable: false,
                value: headList[i].split("#")[1],
              });
            }
          }

          for (let i = 0; i < bodyList.length; i++) {
            if (i != 0) {
              var item = { list: [] };
              for (let j = 0; j < bodyList[i].length; j++) {
                if (j == 0) {
                  item.id = bodyList[i][j];
                } else if (j == 1) {
                  item.name = bodyList[i][j];
                } else if (j == 2) {
                  item.sku = bodyList[i][j];
                } else if (j == 3) {
                  item.barcode = bodyList[i][j];
                } else if (j == 4) {
                  item.productCode = bodyList[i][j];
                } else if (j == 5) {
                  item.prop = bodyList[i][j];
                } else {
                  item[this.percentHeader[j + 1].value] = bodyList[i][j];
                }
                item.list.push(bodyList[i][j]);
              }
              this.percentList.push(item);
            }
          }
        });
      }
    },
  },
  computed: {
    present_wait() {
      let num = this.count_successes + this.count_failed;
      let num100 = num * 100;

      return parseInt(num100 / this.count_excel);
    },
    present_setWait() {
      let num = (this.countSuccess / this.setSuccessList.length) * 100;

      return parseInt(num);
    },
    present_percentWait() {
      let num = this.percentCountSuccess * 100;

      return parseInt(num);
    },
  },
  methods: {
    AlertWarning,
    formatMoney,
    get_languages,

    async getHeaderDatatable() {
      this.warehouseList = [{ id: 0, name: this.use_language.select_library_, disabled: true }],
      this.warehouseId = { id: 0, name: this.use_language.select_library_, disabled: true },

      this.setSuccessHeader = [
        { text: "No", align: "center", sortable: false, value: "no", width: "60px" }, // No
        { text: this.use_language.tb_image, align: "center", sortable: false, value: "photoLink", width: "70px" }, // รูป
        { text: this.use_language.info, align: "left", sortable: false, value: "name", width: "350px" }, // ชื่อ
        { text: this.use_language.type, align: "center", sortable: false, value: "prop1Description", width: "100px" }, // ลักษณะ
        { text: this.use_language.number_product, align: "center", sortable: false, value: "productCode", width: "90px" }, // รหัสสินค้า
        { text: this.use_language.sku, align: "center", sortable: false, value: "sku" }, // SKU
        { text: "Barcode", align: "center", sortable: false, value: "barcode" }, // Barcode
        { text: this.use_language.quantity, align: "center", sortable: false, value: "quantity", width: "90px" }, // จำนวน
      ]

      this.setFailedHeader = [
        { text: "No", align: "center", sortable: false, value: "no", width: "60px" }, // No
        { text: this.use_language.tb_image, align: "center", sortable: false, value: "photoLink", width: "70px" }, // รูป
        { text: this.use_language.info, align: "left", sortable: false, value: "name", width: "350px" }, // ชื่อ
        { text: this.use_language.type, align: "center", sortable: false, value: "prop1", width: "100px" }, // ลักษณะ
        { text: this.use_language.number_product, align: "center", sortable: false, value: "productCode", width: "90px" }, // รหัสสินค้า
        { text: this.use_language.sku, align: "center", sortable: false, value: "sku" }, // SKU
        { text: "Barcode", align: "center", sortable: false, value: "barcode" }, // Barcode
        { text: this.use_language.quantity, align: "center", sortable: false, value: "quantity", width: "90px" }, // จำนวน
        { text: this.use_language.remark, align: "center", sortable: false, value: "remark" }, // หมายเหตุ
      ]
    },

    async toBack(path) {
      this.$router.push("/" + path);
    },
    async getPercentLoading(Round, countLoop) {
      this.percentLoadingWork = true;
      this.percentLoading = 0;
      this.percentLoading = parseInt((Round / countLoop) * 100);
      if (this.percentLoading == 100) {
        this.percentLoadingText = this.use_language.success;
      } else if (this.percentLoading > 0) {
        this.percentLoadingText = this.use_language.loading;
      } else {
        this.percentLoadingText = this.use_language.wait_upload;
      }
    },
    async upload_order_excel() {
      if (this.file_excel == null) {
        this.file_excel = [];
      }
      if (this.warehouseId.id == 0) {
        this.$refs.selcet_shop.focus();
        return;
      }
      if (this.file_excel.length == 0) {
        this.$refs.file_excel.focus();
        return;
      }

      var typeFile = false;
      var file_type = this.file_excel["type"];
      if (file_type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        typeFile = true;
      } else {
        this.AlertWarning(this.use_language.file_type_incorrect);
        return;
      }
      if (typeFile) {
        // อ่านค่าบนไฟล์ excel
        Swal.fire({
          title: this.use_language.save,
          text: this.use_language.save_yes_or_no,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.use_language.submit,
          cancelButtonText: this.use_language.cancel,
        }).then((result) => {
          if (result.value) {
            this.fetch_api_excel();
          }
        });
      }
    },
    async getSelcetWarehouse() {
      await axios.post(
        shopService_dotnet + "Shop/get-warehouse-list",
        {
          shopID: this.ShopID,
        },
        { headers: this.header_token },
      )
      .then((res) => {
        if (res.data.length > 0) {
          for (var s in res.data) {
            this.warehouseList.push({id: res.data[s].id, name: res.data[s].name, shopID: res.data[s].shopID});
          }
        }
      })
      .catch((error) => {});
    },

    async fetch_api_excel() {
      this.count_failed = 0;
      this.count_successes = 0;
      this.present_status = true;
      let body_error = [];
      for (var item in this.dataTable_excal) {
        //  เช็คสถานะการยิงอีกครั้ง
        if (
          this.dataTable_excal[item].status == 0 ||
          this.dataTable_excal[item].status == 3
        ) {
          let body_productMasterItem = [
            {
              id: this.dataTable_excal[item].productMasterItemID,
              productMasterId: this.dataTable_excal[item].productMasterID,
              photoLink: this.dataTable_excal[item].url_img,
              unitPrice: this.dataTable_excal[item].price,
              barcode:
                this.dataTable_excal[item].barcode != null
                  ? this.dataTable_excal[item].barcode.toString()
                  : null,
              sku:
                this.dataTable_excal[item].sku != null
                  ? this.dataTable_excal[item].sku.toString()
                  : null,
              prop1Description: this.dataTable_excal[item].details_attribute1,
              prop2Description: this.dataTable_excal[item].details_attribute2,
              weight: this.dataTable_excal[item].weight,
              cubic1: this.dataTable_excal[item].cubic1,
              cubic2: this.dataTable_excal[item].cubic2,
              cubic3: this.dataTable_excal[item].cubic3,
            },
          ];

          let body_productMaster = {
            id: this.dataTable_excal[item].productMasterID,
            shopId: this.ShopID,
            name: this.dataTable_excal[item].name,
            productCode:
              this.dataTable_excal[item].code != null
                ? this.dataTable_excal[item].code.toString()
                : null,
            prop1: this.dataTable_excal[item].attribute1,
            prop2: this.dataTable_excal[item].attribute2,
            cfCode:
              this.dataTable_excal[item].cf != null
                ? this.dataTable_excal[item].cf.toString()
                : null,
            brand: this.dataTable_excal[item].brand,
            IsProductSet: this.dataTable_excal[item].isproductset,
            acceptableExpiryDay:
              this.dataTable_excal[item].acceptableExpiryDay == null ||
              this.dataTable_excal[item].acceptableExpiryDay === ""
                ? null
                : Number(this.dataTable_excal[item].acceptableExpiryDay),
            acceptableMFGDay:
              this.dataTable_excal[item].acceptableMFGDay == null ||
              this.dataTable_excal[item].acceptableMFGDay === ""
                ? null
                : Number(this.dataTable_excal[item].acceptableMFGDay),
          };

          let stock_list = [
            {
              stockShopID: this.dataTable_excal[item].stockShopID,
              costPrice:
                this.dataTable_excal[item].costPrice === undefined ||
                this.dataTable_excal[item].costPrice == null ||
                this.dataTable_excal[item].costPrice == ""
                  ? null
                  : this.dataTable_excal[item].costPrice,
              price:
                this.dataTable_excal[item].price === undefined ||
                this.dataTable_excal[item].price == null ||
                this.dataTable_excal[item].price == ""
                  ? null
                  : this.dataTable_excal[item].price,
              warehouseID: this.warehouseId.id,
              buffer:
                this.dataTable_excal[item].buffer === undefined ||
                this.dataTable_excal[item].buffer == null
                  ? 0
                  : this.dataTable_excal[item].buffer,
              quantity:
                this.warehouseId.shopID == null &&
                this.dataTable_excal[item].stockShopID == 0
                  ? 0
                  : this.dataTable_excal[item].stock === undefined ||
                    this.dataTable_excal[item].stock == null
                  ? 0
                  : this.dataTable_excal[item].stock,
            },
          ];

          body_productMasterItem[0].stockList = stock_list;

          this.productMaster = body_productMaster;
          this.productMasterItem = body_productMasterItem;

          await axios.post(
            stockService_dotnet + "Stock/update-product",
            {
              productMaster: this.productMaster,
              productMasterItem: this.productMasterItem,
            },
            { headers: this.header_token },
          )
          .then((res) => {
            if (res.data.status == 200) {
              this.count_successes++;
              this.dataTable_excal[item].status = 1;
              this.fetch_api_log(this.dataTable_excal[item]);
            } else {
              this.count_failed++;
              this.dataTable_excal[item].status = 2; //status = 2 ;ของยิงผ่านแต่ข้อมูลซ้ำ
              this.dataTable_excal[item].error = res.data.text;
              body_error.push(this.dataTable_excal[item]);
              this.fetch_api_log(this.dataTable_excal[item]);
            }
          })
          .catch((error) => {
            this.count_failed++;
            this.dataTable_excal[item].status = 3; //status = 3 ; ผิดพลาดที่ดาต้าเบส รอยิงซ้ำอีกรอบ
            this.dataTable_excal[item].error = error;
            body_error.push(this.dataTable_excal[item]);
            this.fetch_api_log(this.dataTable_excal[item]);
          });
        }

        this.fetch_api_present++;
      }

      this.dataTable_excal = body_error;
      this.total_excal = this.count_failed;
      this.updatePage();
      this.dialog = true;
      this.fetch_api_present = 0;
    },

    async fetch_api_log(bodyHistory) {
      await axios.post(
        stockService_dotnet + "Stock/update-history-product-excel",
        {
          shopID: this.ShopID,
          branchID: localStorage.getItem("branch_id"),
          createdByStaffID: localStorage.getItem("staff_id"),
          name:
            bodyHistory.name != null
              ? bodyHistory.name.toString()
              : bodyHistory.name,
          productCode:
            bodyHistory.code != null
              ? bodyHistory.code.toString()
              : bodyHistory.code,
          sku:
            bodyHistory.sku != null
              ? bodyHistory.sku.toString()
              : bodyHistory.sku,
          barcode:
            bodyHistory.barcode != null
              ? bodyHistory.barcode.toString()
              : bodyHistory.barcode,
          cfCode:
            bodyHistory.cf != null
              ? bodyHistory.cf.toString()
              : bodyHistory.cf,
          unitPrice:
            bodyHistory.price != null
              ? bodyHistory.price.toString()
              : bodyHistory.price,
          prop1: bodyHistory.attribute1,
          prop2: bodyHistory.attribute2,
          prop1Desc: bodyHistory.details_attribute1,
          prop2Desc: bodyHistory.details_attribute2,
          productLink: bodyHistory.url_img,
        },
        { headers: this.header_token },
      )
      .then((res) => {})
      .catch((error) => {});
    },

    updatePage(pageIndex) {
      let start = (pageIndex - 1) * this.pageSize;
      let end = pageIndex * this.pageSize;
      this.historyList = this.dataTable_excal.slice(start, end);
      this.page = pageIndex;
      this.length_page = Math.ceil(this.total_excal / this.pageSize);
    },

    async checkProductSet(info) {
      var checkNull = info.filter((x) => x.quantity == null);
      if (checkNull.length > 0) {
        this.$swal({
          type: "warning",
          text: this.use_language.sku_no_specify_quantity,
        });
        this.fileSet_excel = null;
        this.setSuccessList = [];
        this.setFailedList = [];
        this.showSetTable = false;
        return;
      }

      var mainMap = new Map();
      for (var item of info) {
        let key = item.mainSku + "|" + item.mainBarcode;
        if (!mainMap.has(key)) {
          mainMap.set(key, {
            mainSku: item.mainSku,
            mainBarcode: item.mainBarcode,
          });
        }
      }
      var mainList = [...mainMap.values()];
      var res = [];
      var round = 0;

      await this.getPercentLoading(round, mainList.length);
      for (var e of mainList) {
        round++;
        let sSku = info.map((item) => {
          if (e.mainSku == item.mainSku && e.mainBarcode == item.mainBarcode) {
            return {
              subSku: item.subSku,
              subBarcode: item.subBarcode,
              quantity: item.quantity,
            };
          }
        }).filter((x) => x != undefined);

        let response = await axios.post(
          stockService_dotnet + "Stock/check-productset",
          {
            shopID: this.ShopID,
            mainSKU: e.mainSku,
            mainBarcode: e.mainBarcode,
            subSkuList: sSku,
          },
          { headers: this.header_token },
        );

        if (response.data.status == "success") {
          res.push(response.data);
        } else {
          this.$swal({
            type: "error",
            text: response.data.message.th,
          });
          return;
        }
        await this.getPercentLoading(round, mainList.length);
      }
      
      var mainItemIds = res.map((x) => (x.mainProduct ? x.mainProduct.productMasterItemID : 0)).filter((x) => x > 0);
      for (let index = 0; index < res.length; index++) {
        for (let index1 = 0; index1 < res[index].subProducts.length; index1++) {
          const element = res[index].subProducts[index1];

          if (mainItemIds.includes(element.productMasterItemID)) {
            res[index].isPassCheck = false;
            res[index].subProducts[index1].remark = this.use_language.sku_set_not_stack;
          }
        }
      }
      this.setSuccessList = res.filter((x) => x.isPassCheck == true);
      this.setFailedList = res.filter((x) => x.isPassCheck == false);
      this.showSetTable = true;
      this.percentLoadingWork = false;
    },

    async updateProductSet() {
      this.countSuccess = 0;
      for (var item of this.setSuccessList) {
        let response = await axios.post(
          stockService_dotnet + "Stock/update-productset-from-excel",
          {
            isPassCheck: item.isPassCheck,
            mainProduct: item.mainProduct,
            subProducts: item.subProducts,
            staffShopID: localStorage.getItem("staff_id"),
          },
          { headers: this.header_token },
        );
        if (response.data.status == "success") {
          this.countSuccess += 1;
        } else {
          Swal.fire({
            position: "top",
            type: "error",
            toast: true,
            timer: 1500,
            text: this.use_language.product_set_fail,
          });
          return;
        }
        this.fetch_api_present_set++;
      }
      Swal.fire({
        position: "top",
        type: "success",
        toast: true,
        timer: 1500,
        text: this.use_language.product_set_complete,
      });
      this.fileSet_excel = null;
      this.setSuccessList = [];
      this.setFailedList = [];
      this.showSetTable = false;
      this.fetch_api_present_set = 0;
    },

    async updateSyncStock() {
      this.percentCountSuccess = 0;
      var pList = this.percentList;
      var syncList = [];
      for (let i = 0; i < pList.length; i++) {
        var itemSync = { id: 0, shopID: 0, staffShopID: 0, items: [] };

        itemSync.id = pList[i].id;
        itemSync.shopID = this.ShopID;
        itemSync.staffShopID = this.staffShopID;

        var sList = pList[i].list;
        for (let j = 0; j < sList.length; j++) {
          if (j >= 6) {
            var percentValue =
              sList[j] != null && sList[j] != "" ? String(sList[j]) : sList[j];
            if (typeof percentValue != "string") {
              percentValue = "" + percentValue + "";
            }

            itemSync.items.push({
              platformID: this.percentHeader[j + 1].value,
              percent: percentValue,
            });
          }
        }
        syncList.push(itemSync);
      }

      let response = await axios.post(
        stockService_dotnet + "Stock/update-stock-sync-percent-from-excel",
        syncList,
        { headers: this.header_token },
      );
      if (response.data.status == "success") {
        this.percentCountSuccess += 1;
      } else {
        Swal.fire({
          position: "top",
          type: "error",
          toast: true,
          timer: 3000,
          title: "Sync Stock " + this.use_language.fail,
          text: response.data.message.th,
        });
        return;
      }
      this.fetch_api_present_percent++;
    },
  },
};
</script>

<style scoped>
.tablenone {
  border: none !important;
  margin: 10px 0px 10px 0px;
}
.box_img {
  width: 100px;
  height: 100px;
  border: 2px solid #837e7e4f;
  margin: 10px 0px 10px 0px;
}
.theme--light.v-tabs-items {
  background-color: transparent !important;
}
</style>
